import {View} from 'react-native';
import sy from '~/styles';
import {Text, Dialog} from '~/components/controls';
const SaveMessageDialog = ({
  showSaveMessageDialog,
  setShowSaveMessageDialog,
  onSendChatMessage,
}) => (
  <Dialog
    title="Bericht opslaan?"
    visible={showSaveMessageDialog}
    buttons={[
      {
        text: 'Annuleren',
        onPress: () => setShowSaveMessageDialog(false),
      },
      {
        text: 'Opslaan',
        onPress: async () => {
          await onSendChatMessage();
          setShowSaveMessageDialog(false);
        },
      },
    ]}>
    <View style={[sy['py-4']]}>
      <Text>Het getypte bericht is nog niet opgeslagen.</Text>
    </View>
  </Dialog>
);
export default SaveMessageDialog;
